// The ways into an event that is happening now (Devin 2026-10-22): on its
// event day a family mostly wants live results, the competitor lists and the
// schedule, so the feed card offers all three side by side. A way that doesn't
// exist for the event yet (no schedule posted) is left out rather than shown
// as a dead button.
//
// Oireachtas: results, competitor lists (the running order, card beb095f8)
// and the organiser's schedule PDF once posted, as on its event page.

const slug = (event) => (event?.name || "").split(" ").join("+");

/**
 * @param {object} event a listing event (feis, grade exam or Oireachtas)
 * @returns {{key: string, label: string, icon: string, to?: string, href?: string, login?: boolean}[]}
 *   `to` is an in-app route (open with the event in router state), `href` an
 *   outside file opened in a new tab; `login`: the page needs a signed-in
 *   account (sendThroughLogin)
 */
export const happeningNowLinks = (event) => {
  if (!event?._id) return [];
  const isOireachtas = event.eventType === "Oireachtas";
  const links = [
    {
      key: "results",
      label: "Results",
      icon: "emoji_events",
      to: `${isOireachtas ? "/oireachtas/results" : "/results"}/${slug(event)}?id=${event._id}`,
    },
  ];
  links.push({
    key: "competitors",
    label: "Competitor lists",
    icon: "groups",
    to: `/competitors/${slug(event)}?id=${event._id}${isOireachtas ? "&kind=oireachtas" : ""}`,
    login: true,
  });
  if (event.schedulePdfUrl) {
    links.push({ key: "schedule", label: "Schedule", icon: "calendar_month", href: event.schedulePdfUrl });
  }
  return links;
};

// Signed out, a page that needs an account goes through log in and comes back
// (Parent/Auth/SignIn.jsx), on the same keys as the event page's own
// Competitor lists button (FeiseannazViewEvent storeOnCompetitorClick).
export const sendThroughLogin = (event, link, navigate) => {
  localStorage.setItem("path", link.to);
  localStorage.setItem("eventId", event?._id);
  localStorage.setItem("eventType", event?.eventType);
  localStorage.setItem("from", "result");
  localStorage.setItem("isCompetitor", true);
  navigate("/login");
};
